// Generated by CoffeeScript 2.7.0
var MessageGroup;

import BaseModel from './base_model.js';

export default MessageGroup = (function() {
  class MessageGroup extends BaseModel {
    constructor(attrs = {}) {
      super(attrs);
      if (this.icon == null) {
        this.icon = _.sample(_cargo.colored_icons.icons);
      }
    }

  };

  MessageGroup.setAttributes(['name', 'icon']);

  return MessageGroup;

}).call(this);
